/* eslint-disable react/jsx-props-no-spreading */
/**
 * Props spreading is required here because this component extends React.HTMLAttributes
 * and needs to forward all standard HTML div attributes (like className, style, role,
 * aria-* attributes) to the underlying div element. This allows the Alert component
 * to be fully customizable while maintaining its base alert functionality.
 */

import React from 'react';
import clsx from 'clsx';

// Variants are based in _variables.scss > $alert-themes options
type AlertVariant = 'success' | 'info' | 'secondary-info' | 'warning' | 'light' | 'danger';

interface AlertProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode | React.ReactElement;
  variant?: AlertVariant;
  title?: string;
}

export function Alert(props: AlertProps) {
  const {
    children, variant, title, ...rest
  } = props;
  // Fallback to danger if no variant is provided
  const alertVariant = variant || 'danger';
  return (
    <div className={clsx('alert', `alert-${alertVariant} d-flex flex-column align-items-start gap-0`)} {...rest}>
      {title && <p className="alert-title d-block fs-xl gray-blue-400 fw-bold p-0 m-0">{title}</p>}
      {children}
    </div>
  );
}
